import { gatewayApi } from './api';

const unwrap = (response) => response.data?.data ?? response.data;

export const customersService = {
  async listCustomers(params = {}) {
    const response = await gatewayApi.get('/v1/users', { params });
    return unwrap(response);
  },

  async getCustomer(id) {
    const { data } = await gatewayApi.get(`/v1/users/${id}`);
    return unwrap({ data });
  },

  async getDocuments(customerId) {
    const response = await gatewayApi.get(`/v1/users/${customerId}/documents`);
    return unwrap(response);
  },

  async generateUploadUrl(customerId, documentType, fileExtension = 'pdf') {
    const response = await gatewayApi.post('/v1/users/documents/presigned-url', {
      customerId, documentType, fileExtension,
    });
    return unwrap(response);
  },

  async submitDocuments(customerId, { key, documentType, metadata = {} }) {
    const response = await gatewayApi.post(`/v1/users/${customerId}/documents`, {
      documents: [{ fileKey: key, documentType, ...metadata }],
    });
    return unwrap(response);
  },

  async listBankAccounts(customerId) {
    const response = await gatewayApi.get(`/v1/users/${customerId}/bank-accounts`);
    return unwrap(response);
  },

  async generateSession(customerId) {
    // The gateway's GenerateSessionDto requires `customerId`; `userId` is rejected with 400.
    const response = await gatewayApi.post('/v1/auth/session', { customerId }, {
      headers: { 'x-request-id': window.crypto?.randomUUID?.() || `req-${Date.now()}` },
    });
    return unwrap(response);
  },
};

export default customersService;
